import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "./components/Head";

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Předrenderované HTML slouží vyhledávačům a prvnímu zobrazení; klient ho nahradí vlastním vykreslením.
// Hydratace tu nedává smysl: stránky se po načtení dat liší od snímku a React hlásil chybu č. 418.
if (rootElement) {
  createRoot(rootElement).render(app);
}

reportWebVitals();
